import { useState } from 'react';
import {
  FormGroup,
  Label,
  Col,
  Input,
  Button,
  CustomPhoneInput,
  FormFeedback,
} from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function CreateButtonWaba({
  id,
  removeButton,
  onUpdate,
  initialValue,
  isEdit,
}) {
  const buttonTextLabel = useGlotaT('spa.messageBuilder.button.textLabel');
  const buttonTextPlaceholder = useGlotaT('spa.messageBuilder.button.textPlaceholder');
  const buttonActionLabel = useGlotaT('spa.messageBuilder.button.actionLabel');
  const buttonDelete = useGlotaT('spa.messageBuilder.button.delete');
  const buttonPhone = useGlotaT('spa.messageBuilder.button.phone');
  const buttonSite = useGlotaT('spa.messageBuilder.button.site');
  const buttonSiteLinkPlaceholder = useGlotaT('spa.messageBuilder.button.siteLinkPlaceholder');
  const buttonInvalidUrl = useGlotaT('spa.messageBuilder.button.invalidUrl');
  const buttonCall = useGlotaT('spa.messageBuilder.button.call');
  const buttonVisitSite = useGlotaT('spa.messageBuilder.button.visitSite');
  const buttonOfferCode = useGlotaT('spa.messageBuilder.button.offerCode');
  const buttonCopyCodePlaceholder = useGlotaT('spa.messageBuilder.button.copyCodePlaceholder');

  const actionsType = [
    { id: 1, type: 'call', description: buttonCall },
    { id: 2, type: 'link', description: buttonVisitSite },
  ];

  const [buttonData, setButtonData] = useState(initialValue);

  const handleInputsChange = ({ target: { name, value } }) => {

    setButtonData({
      ...buttonData,
      [name]: value,
    });
    handleButtonData({
      ...buttonData,
      [name]: value,
    });
  };

  const handleInputsChangeCopy = ({ target: { name, value } }) => {

    setButtonData({
      ...buttonData,
      [name]: value,
    });
    handleButtonDataCopy({
      ...buttonData,
      [name]: value,
    });
  };

  const handleWithDeleteButton = () => {
    setButtonData({});
    removeButton(id);
  };

  const handleButtonData = ({ id, type, text, actionType, actionText }) => {
    if (type === 'reply') {
      actionType = '';
      actionText = '';
    }

    onUpdate({ id, type, text, actionType, actionText });
  };

  const handleButtonDataCopy = ({ id, type, copyText }) => {
    onUpdate({ id, type, text: 'Copiar código', copyText });
  };

  // https://stackoverflow.com/a/43467144
  const isValidURL = (string) => {
    let url;

    if (string.indexOf(' ') >= 0) {
      return false
    }
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
  }

  return (
    <>
      {buttonData.type === 'reply' && (
        <>
          <Col sm={12} md={8}>
            <FormGroup>
              <Input
                type="text"
                id={'button-text' + id}
                name="text"
                maxLength="20"
                placeholder={buttonTextPlaceholder}
                value={buttonData.text}
                onChange={handleInputsChange}
                disabled={isEdit}
                required
              />
            </FormGroup>
          </Col>
          <Col sm={{ size: 6, offset: 4 }} md={{ size: 2, offset: 0 }}>
            <FormGroup>
              <Button
                color="danger"
                onClick={handleWithDeleteButton}
                disabled={isEdit}
              >
                {buttonDelete}
              </Button>
            </FormGroup>
          </Col>
        </>
      )}
      {buttonData.type === 'action' && (
        <>
          <Col sm={12} md={6}>
            <FormGroup>
              <Label>{buttonActionLabel}</Label>
              <Input
                type="select"
                id={'action-type' + id}
                name="actionType"
                maxLength="20"
                value={buttonData.actionType}
                onChange={handleInputsChange}
                disabled={isEdit}
                required
              >
                {actionsType.map((btn) => (
                  <option key={btn.id} value={btn.type}>
                    {btn.description}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col sm={12} md={6}>
            <FormGroup>
              <Label>{buttonTextLabel}</Label>
              <Input
                type="text"
                id={'button-text' + id}
                maxLength="20"
                name="text"
                value={buttonData.text}
                placeholder={buttonTextPlaceholder}
                onChange={handleInputsChange}
                disabled={isEdit}
                required
              />
            </FormGroup>
          </Col>
          <Col sm={12} md={6}>
            {buttonData.actionType === 'call' && (
              <>
                <FormGroup>
                  <Label>{buttonPhone}</Label>
                  <CustomPhoneInput
                    id={'action-text-call' + id}
                    name="actionText"
                    country={'br'}
                    autoFormat={true}
                    value={buttonData.actionText}
                    onChange={(value) =>
                      handleInputsChange({
                        target: { name: 'actionText', value },
                      })
                    }
                    placeholder="+55 (62) 9999-9999"
                    disabled={isEdit}
                  />
                </FormGroup>
              </>
            )}
            {buttonData.actionType === 'link' && (
              <>
                <FormGroup>
                  <Label>{buttonSite}</Label>
                  <Input
                    type="url"
                    id={'action-text-link' + id}
                    name="actionText"
                    placeholder={buttonSiteLinkPlaceholder}
                    value={buttonData.actionText}
                    onChange={handleInputsChange}
                    disabled={isEdit}
                    required
                    invalid={
                      buttonData.actionText !== '' && !isValidURL(buttonData.actionText)
                    }
                  />
                  <FormFeedback>{buttonInvalidUrl}</FormFeedback>
                </FormGroup>
              </>
            )}
          </Col>
          <Col sm={{ size: 8, offset: 5 }}>
            <FormGroup>
              <Label></Label>
              <Button
                color="danger"
                onClick={handleWithDeleteButton}
                disabled={isEdit}
              >
                {buttonDelete}
              </Button>
            </FormGroup>
          </Col>
        </>
      )}
      {buttonData.type === 'url' && (
        <>
          <Col sm={12} md={6}>
            <FormGroup>
              <Label>{buttonOfferCode}</Label>
              <Input
                type="text"
                id={'button-copytext' + id}
                name="copyText"
                maxLength="15"
                placeholder={buttonCopyCodePlaceholder}
                value={buttonData.copyText}
                onChange={(e) => {
                  const stringValue = String(e?.target?.value ?? '');
                  const processedValue = stringValue.replace(/[^A-Z0-9]/gi, '').toUpperCase();
                  handleInputsChangeCopy({
                    target: { name: 'copyText', value: processedValue },
                  });
                }}
                onInput={(e) => {
                  const target = e.target;
                  const stringValue = String(target.value || '');
                  const processedValue = stringValue.replace(/[^A-Z0-9]/gi, '').toUpperCase();
                  target.value = processedValue;
                }}
                onKeyDown={(e) => {
                  const key = e.key;
                  const isAlphanumeric = /^[A-Z0-9]$/i.test(key);
                  const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key);

                  if (!isAlphanumeric && !isControlKey) {
                    e.preventDefault();
                  }
                }}
                disabled={isEdit}
                required
              />
            </FormGroup>
          </Col>
          <Col sm={{ size: 6, offset: 4 }} md={{ size: 2, offset: 0 }}>
            <FormGroup>
              <Button
                color="danger"
                onClick={handleWithDeleteButton}
                disabled={isEdit}
              >
                {buttonDelete}
              </Button>
            </FormGroup>
          </Col>
        </>
      )}
    </>
  );
}

export default CreateButtonWaba;
